import EnumDataSource from "../utils/enum-data-source.util";

export const SERVICE_PRODUCT_TYPE = 1;
export const HEARING_AID_PRODUCT_TYPE = 2;
export const ACCESSORY_PRODUCT_TYPE = 3;
export const FEE_PRODUCT_TYPE = 4;
export const SUPPLY_PRODUCT_TYPE = 5;
export const COCHLEAR_IMPLANT_PRODUCT_TYPE = 6;
export const FROM_STOCK = 60;
export const STARRED = 61;

const productTypes = {
  [SERVICE_PRODUCT_TYPE]: "Service",
  [HEARING_AID_PRODUCT_TYPE]: "Hearing Aid",
  [COCHLEAR_IMPLANT_PRODUCT_TYPE]: "Cochlear Implant",
  [ACCESSORY_PRODUCT_TYPE]: "Accessory",
  [FEE_PRODUCT_TYPE]: "Fee",
  [SUPPLY_PRODUCT_TYPE]: "Supply"
};

export const PRODUCT_TYPES = new EnumDataSource(productTypes);

// Colored chip styles for product type display (Service → Accessory → Supply → Fee)
export const PRODUCT_TYPE_CHIP_STYLES: Record<
  number,
  { bgcolor: string; color: string }
> = {
  [SERVICE_PRODUCT_TYPE]: { bgcolor: "#e3f2fd", color: "#1565c0" },
  [ACCESSORY_PRODUCT_TYPE]: { bgcolor: "#e8f5e9", color: "#2e7d32" },
  [FEE_PRODUCT_TYPE]: { bgcolor: "#fff3e0", color: "#e65100" },
  [SUPPLY_PRODUCT_TYPE]: { bgcolor: "#f3e5f5", color: "#6a1b9a" }
};

// Fixed display order: Service → Accessory → Supply → Fee
export const PRODUCT_TYPE_ORDER: Record<number, number> = {
  [SERVICE_PRODUCT_TYPE]: 0,
  [ACCESSORY_PRODUCT_TYPE]: 1,
  [SUPPLY_PRODUCT_TYPE]: 2,
  [FEE_PRODUCT_TYPE]: 3
};

const saleStatuses = {
  "-1": "Quote",
  "1": "Draft",
  "2": "Ready to Bill",
  "3": "In Billing",
  "4": "In Suno Collect",
  "999": "Completed",
  "1000": "Canceled"
};

export const saleStatusesByValue = Object.fromEntries(
  Object.entries(saleStatuses).map(([key, value]) => [value.toLowerCase(), key])
);

export const SALE_STATUSES = new EnumDataSource(saleStatuses);
export const SALE_APPOINTMENT_COMPLETION_STATUSES = new EnumDataSource({
  "0": "No Invoices",
  ...saleStatuses
});

export const SALE_QUOTE_STATUS_TYPE = -1;
// A sale's status as served (number, or a string from an older projection) read as "is a quote".
export const isQuoteSaleStatus = (status: unknown) =>
  Number(status) === SALE_QUOTE_STATUS_TYPE;
export const SALE_DRAFT_STATUS_TYPE = 1;
export const SALE_READY_TO_BILL_STATUS_TYPE = 2;
export const SALE_IN_BILLING_STATUS_TYPE = 3;
export const SALE_IN_COLLECTION_STATUS_TYPE = 4;
export const SALE_COMPLETED_STATUS_TYPE = 999;
export const SALE_CANCELED_STATUS_TYPE = 1000;

export const IN_PROGRESS_SALE_STATUSES = [
  SALE_READY_TO_BILL_STATUS_TYPE,
  SALE_IN_BILLING_STATUS_TYPE,
  SALE_IN_COLLECTION_STATUS_TYPE
];
export const FINAL_SALE_STATUSES = [
  SALE_COMPLETED_STATUS_TYPE,
  SALE_CANCELED_STATUS_TYPE
];

// Non-canceled sale statuses for reports filtering
export const NON_CANCELED_SALE_STATUSES = [
  SALE_QUOTE_STATUS_TYPE,
  SALE_DRAFT_STATUS_TYPE,
  SALE_READY_TO_BILL_STATUS_TYPE,
  SALE_IN_BILLING_STATUS_TYPE,
  SALE_COMPLETED_STATUS_TYPE,
  SALE_IN_COLLECTION_STATUS_TYPE
];
export const NON_CANCELED_SALE_STATUSES_STRING =
  NON_CANCELED_SALE_STATUSES.join(",");
export const SALES_LIST_KEY_DEFAULT = "salesList";
export const ACCOUNTS_RECEIVABLE_LIST_KEY_DEFAULT = "accountsReceivableList";

export const AGING_GROUPS = new EnumDataSource({
  "1": "0 - 30",
  "2": "31 - 60",
  "3": "61 - 90",
  "4": ">90"
});
